import { render, staticRenderFns } from "./ChangeEmailModule.vue?vue&type=template&id=01af275f&scoped=true&"
import script from "./ChangeEmailModule.vue?vue&type=script&lang=js&"
export * from "./ChangeEmailModule.vue?vue&type=script&lang=js&"
import style0 from "./ChangeEmailModule.vue?vue&type=style&index=0&id=01af275f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01af275f",
  null
  
)

export default component.exports